/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { omitProps, pickProps } from '@instructure/ui-react-utils';
import { FormFieldLayout } from '../FormFieldLayout';
import { propTypes, allowedProps } from './props';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
---
category: components
---
**/
class FormField extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(FormFieldLayout, {
      ...omitProps(this.props, FormField.allowedProps),
      ...pickProps(this.props, FormFieldLayout.allowedProps),
      label: this.props.label,
      vAlign: this.props.vAlign,
      as: "label"
      // This makes the control in focus when the label is clicked
      // This is needed to prevent the wrong element to be focused, e.g.
      // multi selects Tag-s
      ,
      htmlFor: this.props.id,
      elementRef: this.handleRef,
      margin: this.props.margin
    });
  }
}
FormField.displayName = "FormField";
FormField.componentId = 'FormField';
FormField.propTypes = propTypes;
FormField.allowedProps = allowedProps;
FormField.defaultProps = {
  inline: false,
  layout: 'stacked',
  labelAlign: 'end',
  vAlign: 'middle'
};
export default FormField;
export { FormField };